<template>
  <div :class="{ box: true, 'slide': slide, hide: hide && !selected, 'move-up': answerAnimation, 'selected': selected}" @click="next">
    <div class="text">
      {{ getHint }}
    </div>
    <div :class="{'option-bar': true, 'hide-bar': hideBar}" v-if="selected && !this.data.recordDisable" @click.self="stopRecord">

      <div :class="{'record-box': true, 'record-hide': hideBar}">
        <div :class="{ record: true, recording }" @click="recordButton">
          <font-awesome-icon v-if="!recording" icon="circle"/>
          <font-awesome-icon v-if="recording" icon="stop"/>
        </div>
        <div class="timer" @click.self="stopRecord">
          {{ time }} / 00:60
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import alert from '@/lib/alert'

export default {
  props: {
    data: Object,
    hide: Boolean,
    hideBar: Boolean,
    answerAnimation: Boolean
  },
  name: 'Answer',
  data() {
    return {
      slide: false,
      selected: false,
      playing: false,
      recording: false,
      recordingTime: 0,
      timerTimeOut: null,
      recordingData: null,
    }
  },
  methods: {
    ...mapActions('record', ['nextQuestion', 'addToPath', 'addRecording']),
    ...mapActions('player', ['playerPlay', 'playerStop', 'playerRecordingStart', 'playerRecordingStop']),
    next() {
      if(!this.selected) {
        this.addToPath(this.data.id);
        this.playerStop();
        this.setAbsolute();
        this.slide = true;
        this.selected = true;
        this.$emit('selected', this.data.id);
        if(this.data.recordDisable) { 
          setTimeout(() => {
            this.$emit('stopRecording');
          }, 1000);
        } else {
          setTimeout(this.record, 1000);
        }
      }
    },
    setAbsolute() {
      let element = this.$el;
      let offsetTop = element.offsetTop;
      element.style.position = 'absolute';
      element.style.top = offsetTop + 'px';
    },
    playButton() {
      if(!this.recording) {
        if(this.playing) {
          this.stop();
        } else {
          if(this.playingState) {
            this.playerStop();
            this.play();
          } else {
            this.play();
          }
        }
      } else {
        console.log(`Error: Currently recording`);
        alert.showError('Currently recording');
      }
    },
    play() {
      this.playing = true;
      this.playerPlay({ type: 'micro', payload: this.recordingData }).then(() => {
        this.playing = false;
      }).catch(err => {
        this.playing = false;
        console.log(`Error: ${err}`);
        alert.showError(err);
      });
    },
    stop() {
      this.playerStop();
      this.playing = false;
    },
    recordButton() {
      if(!this.playing) {
        if(!this.recording) {
          this.record();
        } else if(this.recording){
          this.stopRecord();
        }
      } else {
        console.log(`Error: Currently playing`);
        alert.showError('Currently playing');
      }
    },
     record() {
      this.playerRecordingStart().then(() => {
        this.recordingTime = 0;
        this.timer();
        this.recording = true;
      }).catch(err => {
        console.log(`Error: ${err}`);
      })
    },
    stopRecord() {
      this.$emit('stopRecording');
      this.recording = false;
      clearTimeout(this.timerTimeOut);
      this.playerRecordingStop().then(data => {
        this.recordingData = data.data;
        this.addRecording({ answerId: this.data.id, data: data.data, time: this.recordingTime });
      }).catch(err => {
        console.log(`Error: ${err}`);
        alert.showError(err);
      })
    },
    timer() {
      this.recordingTime += 1;
      if(this.recordingTime == 60) {
        this.stopRecord();
      } else {
        this.timerTimeOut = setTimeout(this.timer, 1000);
      }
    }
  },
  computed: {
    ...mapGetters('player', ['playingState']),
    getHint() {
      if(this.data.hint.trim() != '') {
        return this.data.hint;
      } else {
        let array = this.data.text.split(' ');
        if(array[0] && array[1]) {
          return `${array[0]} ${array[1]}...`;
        } else {
          return `${array[0]}...`;
        }
      }
    },
    time() {
      if(this.recordingTime < 10) {
        return '00:0' + this.recordingTime;
      } else {
        return '00:' + this.recordingTime;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.box {
  width: 90%;
  min-height: 4rem;
  background-color: #edc270;
  border-radius: 0.5rem;
  flex-direction: column;
  display: flex;
  margin-bottom: 1rem;
  color: #4f4f4f;
  transition: 0.2s;
  cursor: pointer;
  animation: scale 1s forwards;
  opacity: 0;
  overflow: hidden;

  @keyframes scale {
    0% {
      transform: scaleY(0.5) translateY(2rem);
      opacity: 0;
    }
    100% {
      transform: scaleY(1) translateY(0rem);
      opacity: 1;
    }
  }

  &:hover {
    background-color: #d8b066;
  }

  &:active {
    transform: scale(0.95);
  }

  .text {
    flex: auto;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding-left: 1rem;
    padding-right: 1rem;
    padding-top: 1rem;
    padding-bottom: 1rem;
    font-size: 1.2rem;
    word-break: break-word;
  }
}

.slide {
  animation: slide 1s ease-in forwards;
  opacity: 1;
  @keyframes slide {
    100% {
      top: 0px;
    }
  }
}

.move-up {
  animation: moveUp 1s ease-out forwards;
  opacity: 1;
  top: 0px;
  @keyframes moveUp {
    0% {
      top: 0px;
      transform: translateY(0%)
    }
    100% {
      top: 0px;
      transform: translateY(calc(-100% - 1rem ))
    }
  }
}

.hide {
  animation: hide 0.5s forwards;
  opacity: 1;
  @keyframes hide {
    0% {
      transform: scale(1);
    }
    100% {
      transform: scale(0);
    }
  }
}

.selected {
  cursor: unset;
  &:hover {
    background-color: #edc270;
  }

  &:active {
    transform: unset;
  }
}

.option-bar {
  height: 0rem;
  width: 100%;
  background-color: #caa45d;
  display: flex;
  align-items: center;
  animation: optionAppear 0.5s 0.5s forwards;
  cursor: pointer;
  @keyframes optionAppear {
    0% {
      height: 0rem;
      opacity: 0;
    }
    100% {
      height: 3rem;
      opacity: 1;
    }
  }
}

.hide-bar {
  height: 3rem;
  animation: optionHide 1s forwards;
  @keyframes optionHide {
    0% {
      height: 3rem;
      opacity: 1;
    }
    100% {
      height: 0rem;
      opacity: 0;
    }
  }
}

.record-box {
  opacity: 0;
  height: 100%;
  width: auto;
  display: flex;
  align-items: center;
  padding-left: 1rem;
  animation: recordAppear 0.5s 0.5s forwards;
  @keyframes recordAppear {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  .record {
    width: 1.9rem;
    height: 1.9rem;
    font-size: 1.1rem;
    border-radius: 50%;
    background-color: rgb(224, 224, 224);
    color: rgb(224, 116, 106);
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    transition: 0.3s;
    @media (max-width: 1000px) {
      width: 1.7rem;
      height: 1.7rem;
      font-size: 0.95rem;
    }
  }

  .recording {
    animation: flashing 2s infinite;
    background-color: rgb(224, 116, 106);
    color: rgb(224, 224, 224);
  }

  @keyframes flashing {
    20% {
      background-color: rgb(224, 116, 106);
    }
    50% {
      background-color: rgb(196, 33, 19);
    }
    80% {
      background-color: rgb(224, 116, 106);
    }
  }

  .timer {
    width: 7rem;
    height: 2.2rem;
    margin-left: 0.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    cursor: pointer;
  }
}

.record-hide {
  opacity: 1;
  animation: recordHide 1s forwards;
  @keyframes recordHide {
    0% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }
}

.audio-box {
  transform: scale(0);
  opacity: 0;
  height: 3rem;
  width: 3rem;
  margin-left: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  animation: audioAppear 0.5s 0.5s forwards;
  @keyframes audioAppear {
    0% {
      transform: scale(0);
      opacity: 0;
    }
    100% {
      transform: scale(1);
      opacity: 1;
    }
  }
}

.audio-hide {
  transform: scale(1);
  opacity: 1;
  animation: audioHide 1s forwards;
  @keyframes audioHide {
    0% {
      transform: scale(1);
      opacity: 1;
    }
    100% {
      transform: scale(0);
      opacity: 0;
    }
  }
}

.audio-button {
  background-color: rgb(237, 231, 240);
  width: 2.2rem;
  height: 2.2rem;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: rgb(54, 57, 63);
  transition: 0.3s;
  cursor: pointer;
  font-size: 0.9rem;

  &:hover {
    background-color: rgb(225, 219, 228);
  }
}
  
.playing {
  color: rgb(50, 180, 25);
}
</style>